export const PAT = {
  page: "patients-page",
  title: "patients-title",
  newBtn: "new-patient-btn",
  search: "patient-search-input",
  table: "patients-table",
  emptyState: "patients-empty",
  loading: "patients-loading",
  row: "pat-row",
  viewFhirBtn: "pat-view-fhir-btn",
  editBtn: "pat-edit-btn",
  deleteBtn: "pat-delete-btn",
  // form
  form: "patient-form",
  mrnBadge: "patient-mrn-badge",
  tabDemographics: "pat-tab-demographics",
  tabContact: "pat-tab-contact",
  tabIdentity: "pat-tab-identity",
  tabEmergency: "pat-tab-emergency",
  fFamily: "pat-field-family",
  fGiven: "pat-field-given",
  fMiddle: "pat-field-middle",
  fSuffix: "pat-field-suffix",
  fGender: "pat-field-gender",
  fBirthDate: "pat-field-birthdate",
  fOrg: "pat-field-organization",
  fSsn: "pat-field-ssn",
  fMobile: "pat-field-mobile",
  fHomePhone: "pat-field-home-phone",
  fEmail: "pat-field-email",
  fLine1: "pat-field-line1",
  fLine2: "pat-field-line2",
  fCity: "pat-field-city",
  fState: "pat-field-state",
  fPostal: "pat-field-postal",
  fCountry: "pat-field-country",
  fMarital: "pat-field-marital",
  fLanguage: "pat-field-language",
  fRace: "pat-field-race",
  fEthnicity: "pat-field-ethnicity",
  fBirthsex: "pat-field-birthsex",
  fGenderIdentity: "pat-field-gender-identity",
  fPronouns: "pat-field-pronouns",
  fDeceased: "pat-field-deceased",
  fDeceasedDate: "pat-field-deceased-date",
  fContactRel: "pat-field-contact-rel",
  fContactFamily: "pat-field-contact-family",
  fContactGiven: "pat-field-contact-given",
  fContactPhone: "pat-field-contact-phone",
  saveBtn: "patient-save-btn",
  cancelBtn: "patient-cancel-btn",
  deleteDialog: "delete-patient-dialog",
  confirmDelete: "confirm-delete-patient-btn",
  navPatients: "nav-patients",
  nameLink: "pat-name-link",
  mrnLink: "pat-mrn-link",
  chartPage: "patient-chart-page",
  chartWorkspace: "patient-chart-workspace",
  chartBack: "patient-chart-back",
  chartHeader: "patient-chart-header",
  chartName: "patient-chart-name",
  chartSubtitle: "patient-chart-subtitle",
  chartStatus: "patient-chart-status",
  chartPhone: "patient-chart-phone",
  chartEmail: "patient-chart-email",
  chartAddress: "patient-chart-address",
  chartEmergency: "patient-chart-emergency",
  chartEditBtn: "patient-chart-edit-btn",
  chartMoreBtn: "patient-chart-more-btn",
  chartDomainTabs: "patient-chart-domain-tabs",
  chartDomain: "patient-chart-domain",
  chartTabs: "patient-chart-tabs",
  chartTab: "patient-chart-tab",
  chartClinicalTabs: "patient-chart-tabs",
  chartClinicalTab: "patient-chart-tab",
  chartFrontDeskTabs: "patient-chart-front-desk-tabs",
  chartFrontDeskTab: "patient-chart-front-desk-tab",
  chartBillingTabs: "patient-chart-billing-tabs",
  chartBillingTab: "patient-chart-billing-tab",
  chartAiPanel: "patient-chart-ai-panel",
  chartAiToggle: "patient-chart-ai-toggle",
  chartFrontDeskPanel: "patient-chart-front-desk-panel",
  chartBillingPanel: "patient-chart-billing-panel",
  chartResultsPanel: "patient-chart-results-panel",
  chartResultType: "patient-chart-result-type",
  chartMiscPanel: "patient-chart-misc-panel",
  chartFooter: "patient-chart-footer",
  chartCardDemographics: "patient-chart-card-demographics",
  chartCardContact: "patient-chart-card-contact",
  chartCardEmergency: "patient-chart-card-emergency",
  chartCardEncounters: "patient-chart-card-encounters",
  chartCardDiagnoses: "patient-chart-card-diagnoses",
  chartCardProblemList: "patient-chart-card-problem-list",
  chartCardMedicalHistory: "patient-chart-card-medical-history",
  chartProblemListPanel: "patient-chart-problem-list-panel",
  chartProblemRow: "patient-chart-problem-row",
  chartHistoryRow: "patient-chart-history-row",
  chartHistoryNegative: "patient-chart-history-negative",
  chartViewAllProblems: "patient-chart-view-all-problems",
  chartCardFacts: "patient-chart-card-facts",
  chartCardNotes: "patient-chart-card-notes",
  chartViewAllDemographics: "patient-chart-view-all-demographics",
  chartViewAllContact: "patient-chart-view-all-contact",
  chartViewAllEmergency: "patient-chart-view-all-emergency",
  chartViewAllEncounters: "patient-chart-view-all-encounters",
  chartNewEncounter: "patient-chart-new-encounter-btn",
  chartViewAllDiagnoses: "patient-chart-view-all-diagnoses",
  chartFactEncounters: "patient-chart-fact-encounters",
  chartFactDiagnoses: "patient-chart-fact-diagnoses",
  chartFactAllergies: "patient-chart-fact-allergies",
  chartFactMedications: "patient-chart-fact-medications",
  chartDemographicsPanel: "patient-chart-demographics-panel",
  chartEncountersPanel: "patient-chart-encounters-panel",
  chartEncountersFilters: "patient-chart-encounters-filters",
  chartEncountersSearch: "patient-chart-encounters-search",
  chartNotesPanel: "patient-chart-notes-panel",
  chartAppointmentsPanel: "patient-chart-appointments-panel",
  chartAppointmentsNew: "patient-chart-appointments-new",
  chartAppointmentsUpcoming: "patient-chart-appointments-upcoming",
  chartAppointmentsPast: "patient-chart-appointments-past",
  chartAppointmentsFilter: "patient-chart-appointments-filter",
  chartAppointmentsPrev: "patient-chart-appointments-prev",
  chartAppointmentsNext: "patient-chart-appointments-next",
  chartAppointmentsToday: "patient-chart-appointments-today",
  chartAppointmentRow: "patient-chart-appointment-row",
  chartNotesFilters: "patient-chart-notes-filters",
  chartNotesSearch: "patient-chart-notes-search",
  chartNotesStatusFilter: "patient-chart-notes-status-filter",
  chartNoteRow: "patient-chart-note-row",
  chartNewNote: "patient-chart-new-note-btn",
  chartNewNoteEncounter: "patient-chart-new-note-encounter",
  chartDiagnosesPanel: "patient-chart-diagnoses-panel",
  chartEncounterRow: "patient-chart-encounter-row",
  chartDiagnosisRow: "patient-chart-diagnosis-row",
  chartEncounterDetail: "patient-chart-encounter-detail",
  chartComingSoonMedications: "patient-chart-coming-soon-medications",
  chartComingSoonAllergies: "patient-chart-coming-soon-allergies",
  chartComingSoonDocuments: "patient-chart-coming-soon-documents",
  chartComingSoonNotes: "patient-chart-coming-soon-notes",
  chartComingSoonInsurance: "patient-chart-coming-soon-insurance",
  chartComingSoonAppointments: "patient-chart-coming-soon-appointments",
  chartPmh: "patient-chart-pmh",
  chartPmhSearch: "patient-chart-pmh-search",
  chartPmhAdd: "patient-chart-pmh-add",
  chartPmhAddNegative: "patient-chart-pmh-add-negative",
  chartPmhResults: "patient-chart-pmh-results",
  chartPmhResult: "patient-chart-pmh-result",
  chartPmhTable: "patient-chart-pmh-table",
  chartPmhRow: "patient-chart-pmh-row",
  chartPmhPromote: "patient-chart-pmh-promote",
  chartPmhQuickEntry: "patient-chart-pmh-quick-entry",
  chartPmhQuickChip: "patient-chart-pmh-quick-chip",
  chartPmhNegatives: "patient-chart-pmh-negatives",
  chartPmhNegativeAdd: "patient-chart-pmh-negative-add",
  chartPmhLegend: "patient-chart-pmh-legend",
  chartPmhReview: "patient-chart-pmh-review",
  chartPmhLastReviewed: "patient-chart-pmh-last-reviewed",
  chartPmhRestore: "patient-chart-pmh-restore",
  chartPmhClose: "patient-chart-pmh-close",
  chartPmhPrevious: "patient-chart-pmh-previous",
  chartPmhNext: "patient-chart-pmh-next",
  chartViewAllHistory: "patient-chart-view-all-history",
  chartProblemAdd: "patient-chart-problem-add",
  chartProblemSearch: "patient-chart-problem-search",
  chartProblemResults: "patient-chart-problem-results",
  chartProblemResult: "patient-chart-problem-result",
  chartProblemAddSelected: "patient-chart-problem-add-selected",
  chartProblemTable: "patient-chart-problem-table",
  chartProblemMoveUp: "patient-chart-problem-move-up",
  chartProblemMoveDown: "patient-chart-problem-move-down",
  chartProblemPrimary: "patient-chart-problem-primary",
  chartProblemRemove: "patient-chart-problem-remove",
  smsConsentCard: "patient-sms-consent-card",
  smsConsentStatus: "patient-sms-consent-status",
  smsConsentMethod: "patient-sms-consent-method",
  smsConsentWhen: "patient-sms-consent-when",
  smsConsentDisclosure: "patient-sms-consent-disclosure",
  smsConsentAuthorize: "patient-sms-consent-authorize",
  smsConsentGrant: "patient-sms-consent-grant-btn",
  smsConsentRevoke: "patient-sms-consent-revoke-btn",
  smsConsentNote: "patient-sms-consent-note",
};
